import { render } from "./Overlay.vue?vue&type=template&id=91452e18&scoped=true"
import script from "./Overlay.vue?vue&type=script&lang=ts"
export * from "./Overlay.vue?vue&type=script&lang=ts"

import "./Overlay.vue?vue&type=style&index=0&id=91452e18&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-91452e18"

export default script